import ContactEventsAPI from 'dashboard/api/pipelines/contactEvents';

const state = {
  events: {},
  meta: {},
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getEvents: _state => contactId => _state.events[contactId] || [],
  getMeta: _state => contactId => _state.meta[contactId] || {},
  getUIFlags: _state => _state.uiFlags,
};

export const actions = {
  fetchEvents: async ({ commit }, { accountId, contactId, params = {} }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await ContactEventsAPI.getEvents(accountId, contactId, params);
      const payload = response.data?.data?.payload || [];
      const meta    = response.data?.data?.meta || {};
      commit('SET_EVENTS', { contactId, events: payload, meta });
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  clearEvents: ({ commit }, contactId) => {
    commit('CLEAR_EVENTS', contactId);
  },
};

export const mutations = {
  SET_UI_FLAG(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },

  SET_EVENTS(_state, { contactId, events, meta }) {
    _state.events = { ..._state.events, [contactId]: events };
    _state.meta   = { ..._state.meta,   [contactId]: meta };
  },

  CLEAR_EVENTS(_state, contactId) {
    const { [contactId]: _e, ...restEvents } = _state.events;
    const { [contactId]: _m, ...restMeta }   = _state.meta;
    _state.events = restEvents;
    _state.meta   = restMeta;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
